import { render, staticRenderFns } from "./HandbookLink.vue?vue&type=template&id=1f211485&"
import script from "./HandbookLink.vue?vue&type=script&lang=js&"
export * from "./HandbookLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports